export const BOTS_I18N_ROOT = "circle_ai_bots";
export const CIRCLE_AI_BOT_CONVERSATION_CHANNEL =
  "CircleAi::BotConversationChannel";
export const BOT_TEXT_MAX_LENGTH = 255;
export const BOT_RECENT_CHATS_LIMIT = 5;
export const BOTS_LIST_PATH = "/ai/bots" as const;
export const BOTS_HISTORY_PATH = "/ai/bots/history" as const;
export const BOTS_DETAIL_PATH = "/ai/bots/$botId" as const;
export const BOTS_CONVERSATION_PATH =
  "/ai/bots/$botId/conversations/$conversationId" as const;
